import { render } from "./AchievementsIcon.vue?vue&type=template&id=63bc89db"
import script from "./AchievementsIcon.vue?vue&type=script&lang=js"
export * from "./AchievementsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__